import { Badge, Box, Table } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

import { PaymentPlanHistory, PayoutEventMap } from 'types';

import DateTimeDisplay from '../DateTime';

const columns = [
  {
    heading: 'Name',
    dataKey: 'paymentPlanName',
    render: (cell: any) => {
      return <div>{cell}</div>;
    },
  },
  {
    heading: 'Payment Events',
    dataKey: 'paymentSchedule',
    render: (cell: any, row: any) => {
      return cell?.map((event: any) => {
        return (
          <Box key={event.event} direction="row" alignItems="center" gap="xs">
            <span>
              {
                PayoutEventMap[row.programType as keyof typeof PayoutEventMap].find((e) => e.event === event.event)
                  ?.name
              }{' '}
              - {event?.paymentPercent ? `${event.paymentPercent * 100}%` : '-'}
            </span>
            {event?.paymentPercent && event.pausedDays ? (
              <Badge message={`${event.pausedDays}d hold`} size="sm" variant="primary" />
            ) : null}
          </Box>
        );
      });
    },
  },
  {
    heading: 'Effective Date',
    dataKey: 'effectiveDate',
    render: (cell: any) => {
      return <div>{DateTime.fromISO(cell.toString()).toUTC().toFormat('MMM dd, yyyy')}</div>;
    },
  },
  {
    heading: 'Created By',
    dataKey: 'setBy',
    render: (cell: any) => {
      const user = cell?.user?.name ?? cell?.user?.username ?? 'LightReach';
      return <div>{user}</div>;
    },
  },
  {
    heading: 'Accepted Date',
    dataKey: 'proposedPaymentPlanAcceptedBy',
    render: (cell: any) => {
      const acceptedDate = cell?.date;
      return (
        <div>
          {acceptedDate ? (
            <DateTimeDisplay value={acceptedDate} showDuration={false} fontSize="xs" dateFormat="DD" inline />
          ) : (
            '---'
          )}
        </div>
      );
    },
  },
  {
    heading: 'Accepted By',
    dataKey: 'proposedPaymentPlanAcceptedBy',
    render: (cell: any) => {
      const value = cell?.user?.name ?? cell?.join(', ') ?? '---';
      return <div>{value}</div>;
    },
  },
];

export const PaymentPlanHistoryTable = (paymentPlans: { paymentPlans: PaymentPlanHistory[] }) => {
  return paymentPlans ? (
    <Table
      rowKey="id"
      columns={columns}
      rows={paymentPlans.paymentPlans}
      align="left"
      isScrollable={{
        x: false,
        y: true,
      }}
    />
  ) : null;
};
